// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  text-decoration: none;
}

.style_link__CvkLJ {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__CvkLJ:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__9BJ9G {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__wPQc9 {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__jLV1g {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__RVdHJ {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__xKpaS {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__xKpaS {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__rQ6OY {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__rQ6OY {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__vyHD- {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__vyHD- {
    line-height: 1.5rem;
  }
}

.style_table_key__Zfw6v {
  vertical-align: top;
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
}
@media only screen and (max-width: 450px) {
  .style_table_key__Zfw6v {
    text-transform: none;
  }
}

.style_container__ASBA7 {
  display: flex;
  background-color: var(--color-paper-600);
  padding-bottom: 15px;
}
@media only screen and (max-width: 450px) {
  .style_container__ASBA7 {
    flex-direction: column;
  }
}
.style_container__ASBA7 td {
  padding: 13px 20px !important;
}
@media only screen and (max-width: 450px) {
  .style_container__ASBA7 td {
    padding: 6px 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/components/modules/Lead/Item/style.module.scss","webpack://./src/assets/scss/_breakpoint.scss"],"names":[],"mappings":"AAOA;EACI,qBAAA;ACNJ;;ADQA;EACI,eAAA;EACA,cAAA;ACLJ;ADMI;EACE,0BAAA;ACJN;;ADQA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ACLJ;;ADQI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ACLR;ADOI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ACLR;ADOI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACLR;ACnCE;EFsCE;IAIQ,eAAA;IACA,mBAAA;ECHV;AACF;ADKI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ACHR;AC7CE;EF8CE;IAIQ,eAAA;IACA,mBAAA;ECDV;AACF;ADGI;EACI,mBAAA;ACDR;ACtDE;EFsDE;IAGQ,mBAAA;ECCV;AACF;;AA1DA;EAEI,mBAAA;EDAA,wDAAA;AC6DJ;AChEE;EDCF;IAKQ,oBAAA;EA8DN;AACF;;AA3DA;EACI,aAAA;EACA,wCAAA;EACA,oBAAA;AA8DJ;AC3EE;EDUF;IAKQ,sBAAA;EAgEN;AACF;AA/DI;EACI,6BAAA;AAiER;ACnFE;EDiBE;IAGQ,4BAAA;EAmEV;AACF","sourcesContent":["@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@use \"/src/assets/scss/breakpoint\" as *;\n@use \"/src/assets/scss/theme/typography\" as *;\n.table_key {\n    // text-transform: uppercase;\n    vertical-align: top;\n    @include textShadow();\n    @include mobile {\n        text-transform: none;\n    }\n}\n\n.container {\n    display: flex;\n    background-color: var(--color-paper-600);\n    padding-bottom: 15px;\n    @include mobile {\n        flex-direction: column;\n    }\n    td {\n        padding: 13px 20px !important;\n        @include mobile {\n            padding: 6px 10px !important;\n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `style_link__CvkLJ`,
	"text-gradient-intel": `style_text-gradient-intel__9BJ9G`,
	"text-xs": `style_text-xs__wPQc9`,
	"text-sm": `style_text-sm__jLV1g`,
	"text-base": `style_text-base__RVdHJ`,
	"text-lg": `style_text-lg__xKpaS`,
	"text-xl": `style_text-xl__rQ6OY`,
	"text-leading": `style_text-leading__vyHD-`,
	"table_key": `style_table_key__Zfw6v`,
	"container": `style_container__ASBA7`
};
export default ___CSS_LOADER_EXPORT___;
